<template>
  <v-row>
    <v-col cols="12" class="text-center pa-5">
      <v-img
        src="https://cdn.siap.id/s3/asset%20illustrasi/Illustrasi/maintenance.png"
        lazy-src="https://cdn.siap.id/s3/asset%20illustrasi/Illustrasi/maintenance.png?width=100"
        max-height="400px"
        contain
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <p class="primary--text title">
        <strong
          >Jika Anda sudah aktivasi sebelumnya. Mohon bersabar ya, karena proses
          sinkronisasi membutuhkan waktu 30 menit. <br />Dimungkin juga karena
          akun Anda belum terdaftar di Simpatika ya</strong
        >
        <br />
      </p>
    </v-col>
    <v-col cols="12" class="text-center ma-0 pa-0">
      <v-btn
        depressed
        :to="{ name: 'organisasi.pilih' }"
        class="ma-0 mt-3"
        color="primary"
        >Kembali</v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style>
.v-content__wrap {
  background-color: white;
}
</style>
